var TemplateLibraryTemplatesEmptyView;

TemplateLibraryTemplatesEmptyView = Marionette.ItemView.extend( {
	id: 'qazana-template-library-templates-empty',

	template: '#tmpl-qazana-template-library-templates-empty'
} );

module.exports = TemplateLibraryTemplatesEmptyView;
